import { render, staticRenderFns } from "./RelapseTableComponent.vue?vue&type=template&id=45e84b35&"
import script from "./RelapseTableComponent.vue?vue&type=script&lang=js&"
export * from "./RelapseTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports